var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasNewShopModule)?_c('ShopReborn'):_c('SmartApproachAppConfig')}
var staticRenderFns = []

export { render, staticRenderFns }